<template>
    <emc-card-stats
        color="blue darken-4"
        icon="mdi-school-outline"
        icon-large
        :value="this.grids"
        title="A contratar"
        sub-text="Número de disciplinas a contratar"
        >
        <template v-slot:tools>
            <emc-chart-refresh-status :label="statusLabel" :failed="hasFailed" :error-code="errorCode" />
        </template>
        <template v-slot:actions>
            <emc-button-icon btn-small :disabled="isBusy" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="start()" />
        </template>
        </emc-card-stats>
</template>

<script>

import { getCurrentInstance } from 'vue'
import { mapActions } from 'vuex'
import { useChartRefresh } from '@/composables/useChartRefresh'

export default {
    name: 'EmcChartGridInHiringNumber',
    setup() {
        const { proxy } = getCurrentInstance()

        return useChartRefresh({
            refreshAction: 'chart/ActionGridInHiringNumbersRefresh',
            onFinished: () => proxy.getData()
        })
    },
    data () {
        return {
            grids: '0',
            title: '',
            updated_at: null
        }
    },
    methods: {
        ...mapActions('chart', ['ActionChartGridInHiringNumber']),
        async getData() {
            await this.ActionChartGridInHiringNumber()
                .then((r) => {
                    this.grids = r.data.value
                    this.title = r.data.title
                    this.updated_at = r.data.updated_at

                    // Recarga já em andamento (normalmente a carga noturna):
                    // o card mostra o andamento sem o usuário ter clicado.
                    this.adopt(r.data.refresh)
                })
        }
    },
    created(){
        this.getData()
    }

    
}
</script>